import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EmployeeForm from './EmployeeForm.jsx'
//import _ from 'lodash'

class AddEmployeeComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.employee.employee) {
      return <div><EmployeeForm employee={this.props.employee}></EmployeeForm></div>
    }
    return <div></div>
  }
}

AddEmployeeComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default AddEmployeeComponent
